/* fothermo – Musterseite App-Animationen (Bildschirme aus der Flutter-App nachgebaut) */
(function () {
  'use strict';
  if (window.foAppDemo) return;                     // nur einmal pro Seite, auch wenn mehrere Abschnitte das Skript laden
  window.foAppDemo = true;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var nf1 = function (n) { return n.toFixed(1).replace('.', ','); };
  var wait = function (ms) { return new Promise(function (r) { setTimeout(r, ms); }); };

  function tpl(id) { return document.getElementById(id).content.cloneNode(true); }
  function mount(phone, ids, withTabs) {
    var screen = document.createElement('div');
    screen.className = 'screen';
    screen.appendChild(tpl('tpl-statusbar'));
    ids.forEach(function (id) { screen.appendChild(tpl(id)); });
    if (withTabs) screen.appendChild(tpl('tpl-tabs'));
    var touch = phone.querySelector('.touch');
    phone.insertBefore(screen, phone.firstChild);
    ['l', 'r'].forEach(function (side) {
      var b = document.createElement('span'); b.className = 'phone__side phone__side--' + side; phone.appendChild(b);
    });
    if (touch) screen.appendChild(touch);
    return screen;
  }
  function onVisible(el, fn, once) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { fn(e.isIntersecting); if (e.isIntersecting && once) io.disconnect(); });
    }, { threshold: 0.3 });
    io.observe(el);
  }
  // Finger auf ein Element im Bildschirm setzen
  function touchTo(touch, el) {
    var s = touch.parentNode.getBoundingClientRect(), r = el.getBoundingClientRect();
    touch.style.left = (r.left - s.left + r.width / 2) + 'px';
    touch.style.top = (r.top - s.top + r.height / 2) + 'px';
  }
  async function tap(touch, el, fn) {
    touchTo(touch, el); await wait(800);
    touch.classList.add('is-down'); if (fn) fn(); await wait(180);
    touch.classList.remove('is-down');
  }

  /* 1 · Live-Übersicht: simulierter Sonnentag ------------------------------ */
  document.querySelectorAll('[data-demo="day"]').forEach(function (dayPhone) {
    var sc = mount(dayPhone, ['tpl-overview'], true);
    var q = function (s) { return sc.querySelector(s); };
    var clock = dayPhone.closest('section').querySelector('[data-clock]');
    var H0 = 6, H1 = 19, LOOP = 12000, temp = 38, last = null, t0 = null, running = false;
    var MODES = {
      wait: ['Wartet auf PV-Überschuss', '#99a7ae'],
      pv: ['Heizt mit PV-Überschuss', '#c0d22a'],
      done: ['Zieltemperatur erreicht', '#049cd9']
    };
    function frame(t) {
      if (!running) { last = null; return; }
      if (t0 === null) t0 = t;
      var p = ((t - t0) % LOOP) / LOOP, h = H0 + (H1 - H0) * p;
      if (last !== null && p < last) temp = 38;          // neuer Tag
      var dt = last === null ? 0 : Math.max(0, p - last) * (H1 - H0);
      last = p;
      var surplus = Math.max(0, 3.8 * Math.sin(Math.PI * (h - 7) / 11));
      var power = temp < 60 && surplus > 0.05 ? Math.min(surplus, 3) : 0;
      temp = Math.min(60, temp + power * dt * 2.87);     // 300 l: 1 kWh ≈ 2,87 K
      var mode = temp >= 60 ? 'done' : power > 0.01 ? 'pv' : 'wait';
      q('[data-v="power"]').textContent = nf1(power);
      q('[data-v="barlabel"]').textContent = nf1(power) + '/3,0 kW';
      q('[data-bar]').style.width = (power / 3 * 100) + '%';
      q('[data-v="surplus"]').textContent = nf1(surplus);
      q('[data-v="temp"]').textContent = Math.round(temp);
      q('[data-v="mode"]').textContent = MODES[mode][0];
      q('[data-mode-dot]').style.background = MODES[mode][1];
      var tag = q('[data-tag]');
      tag.className = 'tag ' + (mode === 'pv' ? 'tag--heat' : 'tag--idle');
      q('[data-tag-label]').textContent = mode === 'pv' ? 'Heating' : 'Idle';
      var hh = Math.floor(h), mm = Math.floor((h - hh) * 4) * 15;
      if (clock) clock.textContent = (hh < 10 ? '0' : '') + hh + ':' + (mm < 10 ? '0' : '') + mm;
      requestAnimationFrame(frame);
    }
    onVisible(dayPhone, function (v) {
      if (reduced) return;
      if (v && !running) { running = true; t0 = null; requestAnimationFrame(frame); }
      if (!v) running = false;
    });
  });

  /* 2 · Bedienen per Fingertipp ------------------------------------------- */
  var setPhone = document.querySelector('[data-demo="settings"]');
  if (setPhone) {
    var ss = mount(setPhone, ['tpl-settings'], true);
    ss.querySelectorAll('.tabs span').forEach(function (s, i) { s.classList.toggle('is-on', i === 1); });
    var touch = ss.querySelector('.touch');
    var g = function (s) { return ss.querySelector(s); };
    var MIN = 40, MAX = 75;
    function setMax(v) {
      var pct = (v - MIN) / (MAX - MIN) * 100;
      g('[data-s="max"]').textContent = Math.round(v);
      g('[data-s-fill]').style.width = pct + '%';
      g('[data-s-thumb]').style.left = pct + '%';
    }
    async function play() {
      while (true) {
        setMax(55); g('[data-s-toggle]').classList.remove('is-on'); g('[data-s-min]').classList.remove('is-open');
        var btn = g('[data-s-save]'); btn.classList.remove('is-saved'); btn.textContent = 'Speichern';
        touch.style.transition = 'none'; touch.style.left = '75%'; touch.style.top = '88%';
        await wait(50); touch.style.transition = '';
        await wait(700); touch.classList.add('is-on');
        touchTo(touch, g('[data-s-thumb]')); await wait(850);
        touch.classList.add('is-down');
        touch.style.transition = 'opacity .3s, transform .15s';
        for (var v = 55; v <= 62; v += 0.25) { setMax(v); touchTo(touch, g('[data-s-thumb]')); await wait(28); }
        touch.style.transition = '';
        await wait(250); touch.classList.remove('is-down'); await wait(400);
        await tap(touch, g('[data-s-toggle]'), function () {
          g('[data-s-toggle]').classList.add('is-on'); g('[data-s-min]').classList.add('is-open');
        });
        await wait(800);
        await tap(touch, btn, function () { btn.classList.add('is-pressed'); });
        btn.classList.remove('is-pressed'); btn.classList.add('is-saved'); btn.textContent = 'Gespeichert ✓';
        await wait(1200); touch.classList.remove('is-on');
        await wait(2200);
      }
    }
    if (!reduced) onVisible(setPhone, function (v) { if (v) play(); }, true);
    else { setMax(62); g('[data-s-toggle]').classList.add('is-on'); g('[data-s-min]').classList.add('is-open'); }
  }

  /* 3 · Einrichtung ------------------------------------------------------- */
  var supPhone = document.querySelector('[data-demo="setup"]');
  if (supPhone) {
    var su = mount(supPhone, ['tpl-setup'], false);
    var st = su.querySelector('.touch'), track = su.querySelector('[data-setup-track]');
    var steps = document.querySelectorAll('[data-setup-steps] li');
    var u = function (s) { return su.querySelector(s); };
    function stepTo(i) {
      track.style.transform = 'translateX(' + (-100 * i) + '%)';
      steps.forEach(function (li, k) { li.classList.toggle('is-on', k === i); li.classList.toggle('is-done', k < i); });
    }
    async function playSetup() {
      while (true) {
        stepTo(0); u('[data-found]').classList.remove('is-in'); u('[data-pw]').textContent = '';
        su.querySelectorAll('[data-pick] span').forEach(function (s) { s.classList.remove('is-sel'); });
        u('.setup__done').classList.remove('is-in');
        st.style.transition = 'none'; st.style.left = '70%'; st.style.top = '85%';
        await wait(50); st.style.transition = '';
        await wait(1600); u('[data-found]').classList.add('is-in');
        await wait(700); st.classList.add('is-on');
        await tap(st, u('[data-tap-1]'));
        await wait(300); st.classList.remove('is-on'); stepTo(1);
        await wait(800);
        for (var i = 0; i < 10; i++) { u('[data-pw]').textContent += '•'; await wait(110); }
        st.classList.add('is-on');
        await tap(st, u('[data-tap-2]'));
        await wait(300); st.classList.remove('is-on'); stepTo(2);
        await wait(900); st.classList.add('is-on');
        await tap(st, u('[data-tap-3]'), function () { u('[data-tap-3]').classList.add('is-sel'); });
        await wait(600); st.classList.remove('is-on'); stepTo(3);
        await wait(500); u('.setup__done').classList.add('is-in');
        await wait(3200);
      }
    }
    if (!reduced) onVisible(supPhone, function (v) { if (v) playSetup(); }, true);
    else { stepTo(3); u('.setup__done').classList.add('is-in'); }
  }

  /* 4 · Scroll-Story ------------------------------------------------------ */
  var storyPhone = document.querySelector('[data-demo="story"]');
  if (storyPhone) {
    var sy = mount(storyPhone, ['tpl-overview', 'tpl-settings', 'tpl-device'], true);
    var apps = sy.querySelectorAll('.app'), names = ['overview', 'settings', 'device'];
    // feste Beispielwerte
    var o = apps[0];
    o.querySelector('[data-v="power"]').textContent = '2,4';
    o.querySelector('[data-v="barlabel"]').textContent = '2,4/3,0 kW';
    o.querySelector('[data-bar]').style.width = '80%';
    o.querySelector('[data-v="surplus"]').textContent = '2,6';
    o.querySelector('[data-v="temp"]').textContent = '52';
    o.querySelector('[data-v="mode"]').textContent = 'Heizt mit PV-Überschuss';
    o.querySelector('[data-mode-dot]').style.background = '#c0d22a';
    o.querySelector('[data-tag]').className = 'tag tag--heat';
    o.querySelector('[data-tag-label]').textContent = 'Heating';
    var s2 = apps[1];
    s2.querySelector('[data-s="max"]').textContent = '60';
    s2.querySelector('[data-s-fill]').style.width = '57%';
    s2.querySelector('[data-s-thumb]').style.left = '57%';
    s2.querySelector('[data-s-toggle]').classList.add('is-on');
    s2.querySelector('[data-s-min]').classList.add('is-open');
    var tabs = sy.querySelectorAll('.tabs span');
    function show(name) {
      var i = names.indexOf(name);
      apps.forEach(function (a, k) { a.classList.toggle('is-out', k !== i); });
      tabs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      document.querySelectorAll('.story__step').forEach(function (s) { s.classList.toggle('is-active', s.dataset.screen === name); });
    }
    show('overview');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) show(e.target.dataset.screen); });
    }, { rootMargin: '-45% 0px -45% 0px' });
    document.querySelectorAll('.story__step').forEach(function (s) { io.observe(s); });
  }

  /* 5 · Bausteine --------------------------------------------------------- */
  var cnt = document.querySelector('[data-count-kw]');
  if (cnt) onVisible(cnt, function () {
    var target = parseFloat(cnt.dataset.countKw), bar = document.querySelector('[data-bar-solo]'), t0 = null;
    function step(t) {
      if (!t0) t0 = t;
      var p = Math.min(1, (t - t0) / 1600), e = 1 - Math.pow(1 - p, 3);
      cnt.textContent = nf1(target * e); bar.style.width = (target * e / 3 * 100) + '%';
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }, true);

  var gauge = document.querySelector('[data-gauge]');
  if (gauge) {
    var fg = gauge.querySelector('.gauge__fg'), gv = gauge.querySelector('[data-gauge-v]'), gt0 = null, gRun = false;
    function gstep(t) {
      if (!gRun) return;
      if (!gt0) gt0 = t;
      var p = ((t - gt0) % 6000) / 6000, e = p < .8 ? 1 - Math.pow(1 - p / .8, 2) : 1;
      var temp = 20 + 40 * e;
      gv.textContent = Math.round(temp);
      fg.style.strokeDashoffset = 314 * (1 - temp / 80);
      fg.style.stroke = temp > 50 ? '#ff9f43' : '#049cd9';
      requestAnimationFrame(gstep);
    }
    onVisible(gauge, function (v) { gRun = v && !reduced; if (gRun) { gt0 = null; requestAnimationFrame(gstep); } });
  }

  var tog = document.querySelector('[data-toggle-solo]');
  if (tog && !reduced) setInterval(function () {
    var on = !tog.classList.contains('is-on');
    tog.classList.toggle('is-on', on);
    document.querySelector('[data-power-label]').innerHTML = on ? 'Heizstab<br>eingeschaltet' : 'Heizstab<br>ausgeschaltet';
  }, 2200);
})();
